import t from 'tcomb';

const is_url_regexp = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

const URL = t.refinement(t.String, (url) => is_url_regexp.test(url));

export default URL;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/URL.js
 **/